import React, {useState} from "react"
import {Box, Grid} from "@mui/material"
import {DndContext, DragOverlay} from "@dnd-kit/core"
import DropAreaWithItems from "./DropAreaWithItems"
import DndItem from "./DndItem"
import {getMerkmal, getObjekteFromWidget} from "../../../misc/widget-functions"
import {
    buildDefaultContainers,
    computeDroppedPosition,
    DROP_CONTAINERS,
    findContainerId,
    findItem, getLabelByItem,
    moveItem,
    stripPlacementData,
} from "./drop-area-utils"

export const objectListWithTwoDropAreasPrototypes = [
    {
        key: "objekte",
        type: "SELECTTREE",
        label: "Objekte",
        size: 6,
        options: "objekte",
    },
]

const ObjectListWithTwoDropAreas = ({widget, getDataFromPointer, triggerAction, updateData}) => {
    const unselectedItems = getObjekteFromWidget(widget)
    const pointer = getMerkmal(widget)?.pointer
    const containers = getDataFromPointer(pointer) ?? buildDefaultContainers(unselectedItems)

    const [activeId, setActiveId] = useState(null)

    const handleDragStart = (event) => {
        setActiveId(event.active.id)
    }

    const handleDragEnd = ({ active, over }) => {
        setActiveId(null)
        if (!over) return

        const sourceId = findContainerId(containers, active.id)
        if (!sourceId) return

        const targetId = over.id
        const isTargetDropArea = DROP_CONTAINERS.has(targetId)

        const position = isTargetDropArea
            ? computeDroppedPosition(active.rect.current?.translated, over.rect)
            : {}

        const patchItem = (item) =>
            isTargetDropArea
                ? { ...stripPlacementData(item), answers: item.answers, ...position }
                : stripPlacementData(item)

        updateData(moveItem(containers, active.id, sourceId, targetId, patchItem), pointer)
    }

    const handleRemoveFromArea = (containerId, itemId) => {
        triggerAction("REMOVE_WUNSCH", {containerId, itemId, containers, pointer})
    }

    const activeItem = activeId ? findItem(containers, activeId) : null

    return (
        <DndContext onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
            <Grid container spacing={4}>
                <Grid size={{lg: 5, xs: 12}}>
                    <DropAreaWithItems
                        id="first"
                        title="Das habe ich"
                        items={containers.first}
                        savePointer={pointer}
                        onRemove={handleRemoveFromArea}
                    />
                </Grid>
                <Grid size={{lg: 5, xs: 12}}>
                    <DropAreaWithItems
                        id="second"
                        title="Das plane ich"
                        items={containers.second}
                        savePointer={pointer}
                        onRemove={handleRemoveFromArea}
                    />
                </Grid>
                <Grid size={{lg: 2, xs: 12}}>
                    <Box display="flex" flexDirection={{lg: "column", xs: "row"}} gap="12px" flexWrap="wrap">
                        {containers.unassigned.map((item) => (
                            <DndItem key={item.id} id={item.id} item={item}/>
                        ))}
                    </Box>
                </Grid>
            </Grid>
            <DragOverlay>
                {activeItem ? (
                    <div
                        style={{
                            width: 96,
                            height: 96,
                            boxSizing: "border-box",
                            padding: "16px",
                            backgroundColor: "#ffffff",
                            border: "2px solid #1976d2",
                            borderRadius: "6px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                            cursor: "grabbing",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {getLabelByItem(activeItem)}
                    </div>
                ) : null}
            </DragOverlay>
        </DndContext>
    )
}

export default ObjectListWithTwoDropAreas